var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { staticClass: "pa-1", attrs: { cols: "12" } },
    [
      _c(
        "v-card",
        { staticClass: "soli-round" },
        [
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "v-simple-table",
                [
                  _vm._l(_vm.groupedReports, function (group, groupName) {
                    return _c(
                      "tbody",
                      { key: groupName },
                      [
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "font-weight-bold soli-grey",
                              attrs: { colspan: "2" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(groupName) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(group, function (report) {
                          return _c(
                            "tr",
                            {
                              key: report.link,
                              staticClass: "cursor-pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.$inertia.visit(report.link)
                                },
                              },
                            },
                            [
                              _c(
                                "td",
                                [
                                  _c(
                                    "Link",
                                    {
                                      staticClass: "font-semibold",
                                      attrs: { href: report.link },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(report.title) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(report.subtitle))]),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }